// extracted by mini-css-extract-plugin
module.exports = {"logomark":"Navigation_logomark__1zpLP","navigation":"Navigation_navigation__3Vzsb"};